export default "__VITE_ASSET__Ctd5v2JS__"